// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import {g_path} from '../../utils/path.js';

export const get_path = to=>g_path(`/me${to}`);
